import WindowPanel from "../components/WindowPanel";
import { style } from "../style";

export default function Goals()
{
    const locationList: string[] = [
        "Central City - The most developed city and central location in Techworld.",
        "Central City Outskirts - A less developed area, partially abanonded on the outer edge.",
        "Peroxide Desert - A bright and sunny desert that ages plastic and fine white sand that jams parts.",
        "Sludge Swamps - More of a toxic waste dump than a swamp. It is filled with viscious and caustic goo.",
    ];
    const artReplacementList: string[] = [
        "[7/6/2026] I have redrawn Uvabrite and replaced his art. To be transparent, it's still the AI's design. First, I tried to recreate his design from the ground up but it ended up looking like bad fan art of my own character so I didn't go with that result. In the end, I edited the AI's design and redrew it as pixel art.",
        "[7/7/2026] I have redrawn and replaced the art for Lapsecap completely. I did a quick sketch of him around a year ago, long before I planned to make this web project. The original AI version was terrible so nothing is left over from that."
    ];
    return (
        <>
            <h1 className={style.h1}>World and Development</h1>
            <section className={style.section}>
                <h2 className={style.h2}>The World</h2>
                <div className={style.prose}>
                    <p>
                        Techworld exists in a long-forgotten prototype 16-bit game. The game's data is still alive, in a cartridge, in a console still plugged in but forgotten about in a corner of a game development studio. The power has gone out once or twice in the last few decades but the unnaturally long lasting save battery in the cartridge has preserved the world all this time. The save file is so old that the world has been developing in weird and unexpected ways over many years.
                    </p>
                </div>
                {/* WORLD MAP */}
                <div className={style.panelSingleWrapper}>
                    <WindowPanel
                        title="Teckworld World Map"
                        imagePath="/image/goals/world_map.jpg"
                    />
                </div>
                {/* LOCATION LIST */}
                <WindowPanel
                    title="Tekworld Locations"
                    contentList={locationList}
                />
            </section>

            <section className={style.section}>
                <h2 className={style.h2}>Influences</h2>
                <div className={style.prose}>
                    <p>
                        This project is obviously heavily influenced by Digimon. The other main influence is the modern usage of retro hardware. Many tekbros are based on references to retro hardware or having to take care of it. For example, the techbro Uvabrite is based on yellowing plastic and undoing that yellowing using the "Retro Brite" process using chemicals or UV light to undo the yellowing. I spent a lot of time and too much money trying to collect and re-collect retro hardware in the past. There are also JRPG influences that influence the world where the Tekbros live.
                    </p>
                </div>
                <div className={style.panelGroup}>
                    {/* DIGIVICE */}
                    <WindowPanel
                        title="vices include: digi"
                        imagePath="/image/goals/digivice.jpg"
                    />
                    {/* NUMEMON*/}
                    <WindowPanel
                        title="no, not again!"
                        imagePath="/image/goals/numemon.jpg"
                    />
                </div>
            </section>
            <section className={style.section}>
                <h2 className={style.h2}>Intent</h2>
                <div className={style.prose}>
                    <p>
                        The main intent with this project is to demonstrate my coding abilities. While this web project may appear focused on world development or game development, currently, it's mostly focused on demonstrating my ability to make a website with React, Typescript, and Tailwind CSS. The original idea of the project started as creating the "Catholic Character Codex", documenting Catholic characters in video games. The main reason I changed the direction of this project was the amount of research required. My desire to finish that version of this project still remains but I don't have the time espescially when the main intent was always just to show my coding abilities.
                    </p>
                </div>
            </section>
            <section className={style.section + " "}>
                <h2 className={style.h2}>Art</h2>
                <p>
                    All of the art included here is AI-generated. Personally, I hate AI art but I needed some kind of image to fill in the Tekbro portrait slots. The concepts and general designs are mine, at least. Again, this was about getting this project done in a reasonable amount of time. I would like to replace this art some time soon. The AI-generated map is pretty cool, actually. I will end up redrawing it but I will keep much of the layout.
                </p>
                {/* LOCATION LIST */}
                <WindowPanel
                    title="art replacement progress"
                    contentList={artReplacementList}
                    addedClassGroup="mt-8"
                />
            </section>
            <section className={style.section}>
                <h2 className={style.h2}>Future Plans</h2>
                <div className={style.prose}>
                    <p>
                        I would like to some day more fully develop this project with the intent to develop a mobile monster-raising game. I grew up taking care of a number of Digimon so when I finally got a smart phone, I was disappointed to see that there weren't really any good monster raising games out there.
                    </p>
                    <p>
                        I would also like to extend this web project to redraw all of the art by hand and further flesh out the world. It would all still be rather derivative but in some ways, that's the point. That being said, to make this project less like Digimon and more of its own thing, would be good. The tech theme will likely always remain though.
                    </p>
                </div>
            </section>
        </>
    );
}
